<template>
  <div
    :class="[
      twMerge(
        attrs.class,
        contentSimpleClasses,
        'max-h-auto shadow-pm mx-auto flex h-auto w-full flex-row gap-3 overflow-hidden rounded-xl bg-white p-4 text-sm lg:mx-0',
      ),
    ]"
  >
    <Icon
      :name="service.icon"
      alt="service"
      :class="[twMerge('h-12 w-12 min-w-[48px]', imgSimpleClasses)]"
    />
    <div
      class="bg-p-500 h-full w-[3px] flex-shrink-0"
      :class="lineSimpleClasses"
    />
    <span :class="[twMerge('text-pretty', contentClasses)]">
      <strong v-if="service.title" class="font-semibold">
        {{ `${service.title} ` }}
      </strong>
      <span>{{ service.description }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
/** packages */
import { twMerge } from 'tailwind-merge'

/** types */
import type { TCDPackageService } from '~/src/types/capacity-database'
import type { TGeneral } from '~/src/types/common'

/** components */
const Icon = defineAsyncComponent(() => import('~/components/common/Icon.vue'))

/** props */
const props = withDefaults(
  defineProps<{
    contentClasses?: string
    service?: TCDPackageService | null
    variant?: 'default' | 'simple'
  }>(),
  {
    contentClasses: '',
    service: null,
    variant: 'default',
  },
)

/** app */
const attrs = useAttrs() as TGeneral

/** computed */
const isSimple = computed(() => props.variant === 'simple')
const contentSimpleClasses = computed(() =>
  isSimple.value ? 'flex-col md:flex-row' : '',
)
const imgSimpleClasses = computed(() =>
  isSimple.value ? 'mx-auto md:mx-0 h-[58px] w-[58px] md:h-12 md:w-12' : '',
)
const lineSimpleClasses = computed(() =>
  isSimple.value
    ? 'mt-5 mb-3 !h-[3px] !max-w-full md:mt-0 md:mb-0 md:!h-full md:!max-w-[3px]'
    : '',
)
</script>
